// Temp file for A/B testing, can be deleted after test

let IS_IN_CLOUDFLARE_BUCKET: boolean | null = null;

export function getABTestVideoUrl(youtubeUrl: string, cloudflareVideoPercent: number): string {
    bucketUser(cloudflareVideoPercent);
    console.log('[ARISE AB test] User is in cloudflare bucket:', IS_IN_CLOUDFLARE_BUCKET);

    if (IS_IN_CLOUDFLARE_BUCKET) {
        // Try to get Cloudflare version
        const cloudflareUrl = getCloudflareVersionOfYoutubeVideo(youtubeUrl);
        if (cloudflareUrl) {
            console.log('[ARISE AB test] Returning cloudflare url');
            return cloudflareUrl;
        } else {
            console.log('[ARISE AB test] No cloudflare version of url found, returning youtube');
        }
    }
    // Return original YouTube URL if not in test bucket or no mapping exists
    console.log('[ARISE AB test] Returning Youtube url');
    return youtubeUrl;
}

function bucketUser(cloudflareVideoPercent: number): void {
    // Check if user has already been bucketed
    if (IS_IN_CLOUDFLARE_BUCKET !== null) {
        return;
    }

    if (!percentIsValid(cloudflareVideoPercent)) {
        console.log('[ARISE AB test] cloudflareVideoPercent invalid');
        IS_IN_CLOUDFLARE_BUCKET = false;
        return;
    }

    // Generate random number and bucket user
    const randomValue = Math.random() * 100;
    IS_IN_CLOUDFLARE_BUCKET = randomValue < cloudflareVideoPercent;
    console.log(`[ARISE AB test] Data: cloudflareVideoPercent: ${cloudflareVideoPercent}, randomValue: ${randomValue}`);
}

function percentIsValid(percent: number) {
    return typeof percent === 'number' && percent >= 0 && percent <= 100;
}

function getCloudflareVersionOfYoutubeVideo(youtubeUrl: string): string | null {
    const videoMapping: Record<string, string> = {
        'https://www.youtube.com/watch?v=ECI3eCAxRGw':
            'https://customer-c6kmyujkvesrdmhe.cloudflarestream.com/8fb776397ab99e0d4867875f8044d3e8/iframe',
        // 'placeholder2': '',
        // 'placeholder3': '',
    };

    return videoMapping[youtubeUrl] ?? null;
}
